import React from "react";

// components
import Button from "../../../components/elements/form/Button";

import { FaCheckCircle } from "react-icons/fa";

// router
import { useLocation, useNavigate, useParams } from "react-router-dom";

// state
import { get_service } from "../../../service/api/service";
import { setTitle } from "../../../store/slices/navbar";
import { useAppDispatch, useAppSelector } from "../../../store";
import SweetAlert from "../../../components/ui/popup";
import MakeRequest from "../../../components/ui/modal/MakeRequest";
// import useService from "../hooks/useService.js";

const ViewService: React.FC = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const service = useAppSelector(({ service }) => service.service);

  const loading = useAppSelector(({ service }) => service.loading);
  const isGuest = !location.pathname.startsWith("/dashboard/");
  // const {} = useService();
  const [request, requestSet] = React.useState(false);

  const onLoad = React.useCallback(() => {
    dispatch(setTitle("Services"));
    if (id) {
      const serviceId = Number(id);
      if (Number.isInteger(serviceId) && serviceId > 0) {
        get_service(dispatch, serviceId);
      }
    }
  }, [dispatch, id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (loading) {
    return (
      <div className="w-full">
        <div className="py-12">
          <h2 className="text-center text-gray-500">Loading service...</h2>
        </div>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="w-full py-12 text-center text-gray-500">
        Service not found.
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-3xl font-bold text-left capitalize text-dark">
        {service?.name}
      </h2>

      <div className="grid lg:grid-cols-3 items-start gap-8 mt-8">
        <div className="w-full lg:col-span-2 bg-white rounded-xl shadow-sm overflow-hidden">
          <div
            style={{
              backgroundImage: `url(${service?.image})`,
              backgroundSize: "cover",
            }}
            className="relative w-full h-[400px]"
          >
            <div className="absolute inset-0 bg-gradient-to-t from-dark/50 to-transparent" />
            <div className="absolute top-4 right-4">
              <span
                className={`px-3 py-1 text-sm font-semibold rounded-full ${
                  service.is_open
                    ? "bg-customgreen text-primary-800"
                    : "bg-red-100/30 text-red-800"
                }`}
              >
                {service.is_open ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
          <div
            className="text-lg font-medium text-gray-800 p-6"
            dangerouslySetInnerHTML={{ __html: service?.description || "" }}
          />
        </div>

        <div className="w-full space-y-4 p-6 bg-white shadow-sm rounded-xl">
          <h3 className="text-2xl font-bold text-primary-700">
            What's Included
          </h3>
          <div className="space-y-4">
            {service?.packages && service?.packages?.length > 0 ? (
              service?.packages.map((item) => (
                <div
                  className={`text-gray-800 text-lg font-medium capitalize flex items-center space-x-3 ${""}`}
                  key={item?.id}
                >
                  <FaCheckCircle className="text-primary-200" />
                  <span>{item.name}</span>
                </div>
              ))
            ) : (
              <div className="text-red-500">No packages found</div>
            )}
          </div>

          <div className="mt-3">
            <Button
              type="button"
              title="Continue"
              loading={loading}
              onHandler={() =>
                isGuest ? navigate("/login") : requestSet(true)
              }
              className="lg:w-full px-6 py-2 text-sm bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-secondary-400 focus:ring-opacity-50"
            />
          </div>
        </div>
      </div>

      {service && (
        <MakeRequest
          id={String(service.id)}
          visible={request}
          onFinish={() => requestSet(false)}
          type="new"
        />
      )}
      <SweetAlert />
    </div>
  );
};

export default ViewService;
